import { render, staticRenderFns } from "./InvoiceItemsComponent.vue?vue&type=template&id=3abf5b1c&scoped=true"
import script from "./InvoiceItemsComponent.vue?vue&type=script&lang=js"
export * from "./InvoiceItemsComponent.vue?vue&type=script&lang=js"
import style0 from "./InvoiceItemsComponent.vue?vue&type=style&index=0&id=3abf5b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abf5b1c",
  null
  
)

export default component.exports